import React, { useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { TableLoaderRow, TableEmptyRow } from "../../components/TableLoader";
import { Dropdown, Card, Table, Badge, Col, Spinner, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import Pagination from "../../components/Pagination";
import moment from "moment";
import S3Image from "../../components/S3Image";
import AddConfig from "../../components/Modal/AddConfig";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteJobCategory,
  deleteServiceCategory,
  getJobCategoryList,
  getServiceCategoryList,
  postJobCategory,
  postServiceCategory,
  updateJobCategory,
  updateServiceCategory,
} from "../../../services/UserServices/UserService";

export default function CategoryConfig(props) {
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [data, setData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [editCategory, setEditCategory] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [search, setSearch] = useState("");

  const item = location?.state?.item;

  const pageTittle = item;

  async function categoryListData() {
    setLoader(true);
    if (item === "Job") {
      try {
        const res = await getJobCategoryList(currentPage, 10, search);
        setData(res);
        setLoader(false);
      } catch (error) {
        console.log(error?.response);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    } else {
      try {
        const res = await getServiceCategoryList(currentPage, 10, search);
        setData(res);
        setLoader(false);
      } catch (error) {
        console.log(error?.response);
        toast.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    }
  }

  const totalItems = data?.data?.data.count;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    categoryListData();
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(0);
    const delayDebounce = setTimeout(() => {
      categoryListData();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    categoryListData();
  }, [currentPage]);

  const deleteHandler = async (id) => {
    setLoader(true);
    const handler =
      item === "Job" ? deleteJobCategory(id) : deleteServiceCategory(id);
    try {
      const res = await handler;
      categoryListData();
      toast.success("Category deleted successfully");
    } catch (error) {
      toast.error("Error occured while deleting category");
      setLoader(false);
    }
  };

  return (
    <div className="qx-page">
      <PageTitle
        pageTitle={pageTittle || "Category Config"}
        subtitle="Manage category items and images"
        actions={
          <>
            <Button variant="outline-secondary" onClick={() => navigate("/category")}>
              Back
            </Button>
            <Button className="btn-primary qx-btn-brand" onClick={() => setAddCategoryModal(true)}>
              + Add Category
            </Button>
          </>
        }
      />
      <Card className="qx-filter-card border-0 shadow-none mb-4">
        <div className="qx-search-wrap">
          <input
            type="text"
            className="form-control"
            placeholder="Search categories..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </Card>
      <Card className="qx-table-card">
        <Card.Body>
          <Table>
            <thead>
              <tr>
                <th>
                  <strong>S.NO</strong>
                </th>
                <th>
                  <strong>Image</strong>
                </th>
                <th>
                  <strong>Category</strong>
                </th>
                <th>Created On</th>
                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={5} />
              ) : !data?.data?.data?.categories?.length ? (
                <TableEmptyRow colSpan={5} message="No categories found" />
              ) : (
                data?.data?.data?.categories?.map((item, i) => (
                    <tr key={item.id} className={i % 2 === 0 ? "even-row" : ""}>
                      <td>{i + 1}</td>
                      <td>
                        <div
                          style={{
                            backgroundColor: "black",
                            width: "44px",
                            borderRadius: "10px",
                            height: "44px",
                          }}
                        >
                          <S3Image
                            imageKey={item?.image}
                            type={"Profiles"}
                            fileType={"profile-image"}
                            style={"profile-photo"}
                          />
                        </div>
                      </td>
                      <td>
                        {item?.name?.length > 30
                          ? item?.name?.slice(0, 25) + ".."
                          : item?.name}
                      </td>
                      <td>{moment(item?.createdAt).format("ll")}</td>

                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="info light"
                            className="qx-action-toggle"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          {!item?.isDeleted && (
                            <Dropdown.Menu>
                              {!item?.isDeleted && (
                                <Dropdown.Item
                                  onClick={() => {
                                    setEditCategory(true);
                                    setSelectedItem(item);
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                onClick={() => deleteHandler(item?._id)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          )}
                        </Dropdown>
                      </td>
                    </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && data?.data?.data?.categories?.length > 0 && (
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
      {addCategoryModal && (
        <AddConfig
          title={`Add ${item}`}
          buttonTitle={"Add"}
          show={addCategoryModal}
          onHide={() => setAddCategoryModal(false)}
          api={item === "Job" ? postJobCategory : postServiceCategory}
          componentId={item?._id}
          refresh={categoryListData}
        />
      )}
      {editCategory && (
        <AddConfig
          title={`Edit ${item}`}
          buttonTitle={"Save"}
          show={editCategory}
          onHide={() => setEditCategory(false)}
          api={item === "Job" ? updateJobCategory : updateServiceCategory}
          componentId={item?._id}
          refresh={categoryListData}
          selectedItem={selectedItem}
        />
      )}
    </div>
  );
}
